<div class="table-container">
  <app-promotion-banner></app-promotion-banner>

  @if (canShowFilters() || shouldShowDateFilter) {
  <div class="row">
    <ng-container>
      @if (canShowFilters()) {
      <ng-container *ngTemplateOutlet="filterButtons"></ng-container>
      }
    </ng-container>
  </div>
  }

  <ng-template #filterButtons>
    <div class="filters-panel">
      <div class="filters-header">
        <div class="header-left">
          <mat-icon class="filter-icon">tune</mat-icon>
          <span class="filters-title">Filters</span>
          @if (hasActiveFilters()) {
          <span class="active-count"> {{ getActiveFiltersCount() }} active </span>
          }
        </div>
        <div class="header-right">
          <!-- Search Input -->
          @if (!isDriver && !jwtAuth.isDoctor()) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              [formControl]="searchControl"
              placeholder="Search orders..."
              #input
            />
            @if (searchControl.value) {
            <button
              mat-icon-button
              matSuffix
              (click)="clearSearch()"
              type="button"
              class="clear-search-btn"
              matTooltip="Clear search"
            >
              <mat-icon>close</mat-icon>
            </button>
            }
          </mat-form-field>
          }
          <!-- Export Button for Appointments/Active Views -->
          @if (status === 'waiting_room' || status === 'active') {
          <button
            mat-raised-button
            color="primary"
            class="export-btn"
            (click)="status === 'active' ? exportActiveOrders() : exportAppointments()"
            [disabled]="loading || !dataSource?.data?.length"
          >
            <mat-icon>download</mat-icon>
            Export
          </button>
          } @if (hasActiveFilters()) {
          <button mat-button class="clear-all-btn" (click)="clearAllFilters()">
            <mat-icon>clear</mat-icon>
            Clear All
          </button>
          }
        </div>
      </div>

      <div class="filters-grid">
        @for (filter of filtersConfig; track filter) { @if (!shouldHideFilter(filter)) {
        <div class="filter-item">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-dropdown">
            <mat-label>{{ filter.label }}</mat-label>
            <mat-select
              [multiple]="filter.multi"
              [formControl]="filterForm.controls[filter.key]"
              [panelClass]="'custom-filter-panel'"
            >
              @if (filter.multi) {
              <mat-select-trigger>
                <span class="select-trigger-text">{{ getSelectedFilterText(filter) }}</span>
              </mat-select-trigger>
              }
              <!-- Search input for filters with many options -->
              @if (shouldShowFilterSearch(filter)) {
              <div class="filter-search-header" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-search-field">
                  <mat-icon matPrefix>search</mat-icon>
                  <input
                    matInput
                    [placeholder]="'Search ' + filter.label.toLowerCase() + '...'"
                    [value]="getFilterSearchText(filter.key)"
                    (input)="setFilterSearchText(filter.key, $event.target.value)"
                    (keydown)="$event.stopPropagation()"
                  />
                  @if (getFilterSearchText(filter.key)) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="clearFilterSearch(filter.key); $event.stopPropagation()"
                    type="button"
                  >
                    <mat-icon>clear</mat-icon>
                  </button>
                  }
                </mat-form-field>
              </div>
              } @if (filter.multi && filter.options && filter.options.length > 1) {
              <div class="select-all-header">
                <button
                  mat-button
                  (click)="toggleSelectAll(filter); $event.stopPropagation()"
                  class="select-all-button"
                >
                  <mat-icon>{{
                    isAllOptionsSelected(filter) ? 'check_box' : 'check_box_outline_blank'
                  }}</mat-icon>
                  {{ isAllOptionsSelected(filter) ? 'Deselect All' : 'Select All' }}
                </button>
              </div>
              } @for (option of getFilteredOptions(filter); track option) {
              <mat-option [value]="option.value">
                {{ getFilterOptionLabel(filter, option) }}
              </mat-option>
              }
            </mat-select>
            <!-- Individual filter clear button -->
            @if (isFilterActive(filter)) {
            <button
              mat-icon-button
              matSuffix
              (click)="clearSingleFilter(filter); $event.stopPropagation()"
              type="button"
              class="clear-filter-btn"
              matTooltip="Reset to default"
            >
              <mat-icon>close</mat-icon>
            </button>
            }
          </mat-form-field>
        </div>
        } }

        <!-- Date Filter -->
        @if (shouldShowDateFilter) {
        <div class="filter-item date-filter-item">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-dropdown">
            <mat-label>Date Range</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="datePicker">
              <input matStartDate placeholder="Start date" formControlName="start" />
              <input
                matEndDate
                (dateChange)="dateChanged($event)"
                placeholder="End date"
                formControlName="end"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
            @if (isDateFilterActive()) {
            <button
              mat-icon-button
              matSuffix
              (click)="clearDateFilter(); $event.stopPropagation()"
              type="button"
              class="clear-date-filter-btn"
              matTooltip="Clear date range"
            >
              <mat-icon>close</mat-icon>
            </button>
            }
            <mat-date-range-picker #datePicker></mat-date-range-picker>
          </mat-form-field>
        </div>
        }

        <!-- Apply Filters Button -->
        <div class="filter-item apply-filter-item">
          <button
            mat-flat-button
            color="primary"
            (click)="applyFilters()"
            class="apply-filters-btn"
          >
            <mat-icon>check_circle</mat-icon>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #searchInput>
    @if (!isDriver && !jwtAuth.isDoctor()) {
    <mat-form-field class="no-padding mm-py-5 mm-mr-5" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="search" #input />
    </mat-form-field>
    }
  </ng-template>

  @if (isMobile ? !isDriver:true) {
  <mat-card appearance="outlined">
    <div class="mat-elevation-z0 table-inner">
      <div style="overflow-x: auto">
        <table
          class="table-class orders-table"
          #table
          mat-table
          [dataSource]="dataSource"
          matSort
        >
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                #selectAll
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row; let i = index">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleRow(row) : null"
                [checked]="selection.isSelected(row)"
                [disabled]="isRowDisabled(row, i)"
                [aria-label]="checkboxLabel(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="createddate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Received</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              {{ element.created_At | date : 'dd/MM/yyyy h:mm:ss a' }}
              <div class="mt-2">{{ element.totalDiff }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="bookingTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Booking Time</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              @if (element.booking_time) {
              <span
                >{{ element.booking_time.format('DD/MM/YYYY') }}<br />{{
                  element.booking_time.format('h:mm A')
                }}</span
              >
              } @if (!element.booking_time) {
              <span>-</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="source">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              @if (admin==='1' || jwtAuth.isBusiness()) {
              <span
                [ngStyle]="{
                  color:
                    element.locationstatus === 1
                      ? '#6ABD35'
                      : element.locationstatus === 2
                      ? '#FF7901'
                      : 'black'
                }"
                >{{ element.locationname }}<br
              /></span>
              }
              <span [ngStyle]="{ color: 'black' }">{{ element.source }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ jwtAuth.isClinician() ? 'Patient Name' : 'Customer Name' }}
            </th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              {{ element.patientName ?? element.firstName + ' ' + element.lastName }}
              <!-- <mat-icon
                *ngIf="admin === '1'"
                class="icon--sm"
                [ngClass]="element.userVerification.color"
                [svgIcon]="element.userVerification.icon"
                [matTooltip]="element.userVerification.displayName"
                matTooltipHideDelay="800"
              ></mat-icon> -->
            </td>
          </ng-container>
          <ng-container matColumnDef="orderid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{
                jwtAuth.isClinician()
                  ? 'Patient
              Details'
                  : 'Order Details'
              }}
            </th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              <div>{{ element.uniqueOrderId }}</div>
              @if (!jwtAuth.isTelehealthPharmacyUser()) {
              <div class="mt-2">
                {{ element.non_Script }}&times; Items {{ element.script }}&times; Script
              </div>
              }
              @if (element?.external_reference_id) {
              <div class="mt-2">Ext. Ref: {{ element.external_reference_id }}</div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="orderDetails">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Details</th>
            <td mat-cell *matCellDef="let element" class="row-class">
              <span class="mobile-label"></span>
              <div>{{ element.uniqueOrderId }}</div>
              @if (!jwtAuth.isTelehealthPharmacyUser()) {
              <div class="mt-2">
                {{ element.non_Script }}&times; Items {{ element.script }}&times; Script
              </div>
              }
              <div class="mt-2">
                {{ element.patientName ?? element.firstName + ' ' + element.lastName }}
              </div>
              @if (element?.external_reference_id) {
              <div class="mt-2">Ext. Ref: {{ element.external_reference_id }}</div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="totalStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ isDriver ? 'Payment Status' : 'Total' }}
            </th>
            <td mat-cell *matCellDef="let element">
              @if (length!=0) {
              <div>
                <span class="mobile-label"></span>
                @if (!isDriver) {
                <div>{{ element.orderTotal | currency }}</div>
                }
                @if (!jwtAuth.isTelehealthPharmacyUser()) {
                <div class="mt-2" [class]="{ 'mm-text-pink': element.paymentStatus === '0' }">
                  {{ getPaymentStatus(element.source, element.paymentStatus) }}
                </div>
                }
              </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="ordertype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              (click)="$event.stopPropagation()"
            >
              <div
                #doorDashiFrameTriggers
                [id]="'dd-iframe-trigger' + i"
                [ngClass]="{
                  'mm-text-pink': element.delivery_Tracking != null,
                  'has-link': element.delivery_Tracking != null
                }"
                (click)="openDeliveryTracking(element.delivery_Tracking)"
              >
                {{ getdeliveryType(element.orderType, element.deliveryPartnerName) }}
              </div>
              <!-- <div #doorDashiFrames [id]="'dd-iframe-' + i" *ngIf="element.showDeliveryTracking" class="iframe">
              <iframe width="100%" height="100%" src="https://www.doordash.com/drive/portal/track/5a7e78de-ed92-4c55-8c02-89ced60ced14" frameborder="0"></iframe>
            </div> -->
            </td>
          </ng-container>
          <ng-container matColumnDef="important">
            <th mat-header-cell *matHeaderCellDef>
              <span>Important</span>
              <mat-icon class="mm-ml-2" inline>warning</mat-icon>
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <ul>
                @for (item of element.importantSurveyData; track item) {
                <li [ngClass]="{ 'mm-fw-700': item.bold }" [innerHtml]="item.label"></li>
                }
              </ul>
            </td>
          </ng-container>
          <ng-container matColumnDef="preview">
            <th mat-header-cell *matHeaderCellDef>
              <span>Preview Document</span>
            </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div
                class="d-flex flex-column justify-content-center align-items-center mm-gap-5"
              >
                @if (element.source !== 'LumiPharmacy') {
                <button mat-button (click)="previewOrderDocument(element)">
                  Preview Document
                </button>
                } @if (jwtAuth.isClinician() && canShowEscalateButton(element)) {
                <button mat-stroked-button (click)="escalateOrder(element)">Escalate</button>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="orderstatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <div fxLayout="column" fxLayoutGap="8px" class="mm-my-3">
                <div>
                  <span
                    [ngStyle]="{
                      color: element.orderStatus === 'New' ? '#0081ff' : '#ff8a48'
                    }"
                  >
                    {{
                      getOrderStatusLabel(element.orderStatus, element?.has_pending_data_form)
                    }}
                    <br />
                    <span [ngStyle]="{ color: 'black' }">{{
                      jwtAuth.isClinician() && status === 'clinic_to_action'
                        ? element.clinic_to_action_time
                        : element.timeDif
                    }}</span>
                    <br />
                  </span>
                </div>
                @if (element.statusCodeName) {
                <div class="d-flex justify-content-center">
                  <mat-chip-listbox>
                    <mat-chip-option
                      (click)="goToOrder(element.orderId, element)"
                      class="mm-order-status-chip"
                      >{{ element.statusCodeName }}</mat-chip-option
                    >
                  </mat-chip-listbox>
                </div>
                } @if (dataOrder.isClinicianNotesVisible(element.orderStatus)) {
                <div class="notes-section">
                  @if (element.clinician_notes) {
                  <div class="notes-preview-wrapper">
                    <div
                      class="notes-preview"
                      [innerHTML]="formatNotes('clinician', element.clinician_notes)"
                    ></div>
                    @if (jwtAuth.isAdmin()) {
                    <span class="history-hint"> Full history available in order details </span>
                    }
                  </div>
                  } @if (!dataOrder.isClinicianNotesReadOnly(element.orderStatus)) {
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="openAddClinicianNoteDialog($event, element)"
                  >
                    <span>{{
                      jwtAuth.isClinician()
                        ? 'Add Note'
                        : 'Add Quick Note to
                          Clinician'
                    }}</span>
                  </button>
                  }
                </div>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="clinician">
            <th mat-header-cell *matHeaderCellDef>Clinician</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <app-clinician-select
                [selectedClinician]="element.selectedClinician"
                [clinicians]="element.availableClinicians"
                [assignedClinician]="element.assignedClincianDetails"
                [orderAssignStatus]="element.order_assign_status"
                [appearance]="'outline'"
                [label]="'Clinician'"
                (clinicianChange)="onClinicianChange($event, element)"
              >
              </app-clinician-select>
            </td>
          </ng-container>
          <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef>Owner</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div class="notes-section">
                @if (element.currentOwner) {
                <div class="notes-preview-wrapper">
                  <div
                    class="notes-preview"
                    [innerHTML]="formatNotes('owner', element.currentOwner)"
                  ></div>
                  @if (jwtAuth.isAdmin()) {
                  <span class="history-hint"> Full history available in order details </span>
                  }
                </div>
                }
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openAddOwnerNoteDialog($event, element)"
                >
                  <span>Add Owner Note</span>
                </button>
              </div>
            </td>
          </ng-container>
          <!-- <ng-container *ngIf="inline===true" matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef> Owner </th>
            <td mat-cell *matCellDef="let element" (change)="changeOwner()">
            </ng-container> -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td
              mat-cell
              *matCellDef="let element"
              (click)="$event.stopPropagation()"
              class="action-row"
            >
              <div fxLayout="row" fxLayoutAlign="center center">
                @if (_actions(element).length === 0 && hasNoActions()) {
                <span class="filler"></span>
                } @else { @if (!jwtAuth.isDriver() && !jwtAuth.isClinician()) {
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                }
                <mat-menu #menu="matMenu">
                  @for (action of _actions(element); track action) {
                  <button
                    (click)="onQuickAction(element, action)"
                    mat-menu-item
                    [class.reminder-menu-item]="
                      action === 'Send Manual Reminder' &&
                      element.pending_booking_reminder_sent_at
                    "
                  >
                    <span>{{ actionAlias(action, element.orderStatus) }}</span>
                    @if (action === 'Send Manual Reminder' &&
                    element.pending_booking_reminder_sent_at) {
                    <span class="reminder-sent-hint">
                      Last sent:
                      {{
                        element.pending_booking_reminder_sent_at
                          | convertToLocalTime : 'DD/MM/YYYY h:mm A'
                      }}
                    </span>
                    }
                  </button>
                  }
                </mat-menu>
                }
                <div fxLayout="column" fxLayoutAlign="start stretch">
                  <span
                    class="mm-text-accent"
                    [class.resume-order-btn]="element.actionText === 'Resume'"
                    [class.start-consult-btn]="element.actionText === 'Start Consultation'"
                    [class.started-order-btn]="element.actionText === 'Started'"
                    (click)="goToOrder(element.orderId, element)"
                  >
                    {{ element.actionText }}
                  </span>
                  @if (isOrderAssignStatusChipVisible) {
                  <mat-chip-listbox class="mm-mt-3" [hideSingleSelectionIndicator]="true">
                    <mat-chip-option
                      [style.backgroundColor]="
                        getOrderStatusChipsColor(element.order_assign_status)
                      "
                      class="status-chip"
                      selected
                    >
                      {{ element.orderAssignmentNotes }}
                    </mat-chip-option>
                  </mat-chip-listbox>
                  <!-- Consult Outcome -->
                  @if (element.consult_outcome) {
                  <span class="mm-mt-1 consult-outcome">
                    {{ element.consult_outcome | titlecase }}
                  </span>
                  } }
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; let i = index; columns: displayedColumns"
            [ngClass]="getRowClass(row, i)"
            [class.disabled-row]="isRowsDisabled()"
            [class.no-filler]="hasNoActions()"
            class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"
            [ngStyle]="{ 'background-color': row.rowBackgroundColor }"
          ></tr>
        </table>
      </div>
      @if ( length >= 0) {
      <mat-toolbar #paginator class="custom-paginator">
        <span class="grow">Page {{ pageIndex }} of {{ lastPage }}</span>
        <div class="grow">
          @if (length==0) {
          <div>No Orders To Be Displayed</div>
          }
          <span class="grow">{{ from }} - {{ to }} of {{ length }} Results</span>
          <span class="mobile-label"></span>
        </div>
        <span class="custom-paginator_options-hold">
          <mat-form-field class="page-size-field mm-standard-field" style="width: 75px">
            <mat-select (selectionChange)="pageSizeChange($event)" [(value)]="pageSize">
              @for (option of [50, 100, 500, 1000]; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <span>
            <button
              disableRipple
              mat-icon-button
              [disabled]="pageIndex <= 1"
              (click)="getFirstPage()"
            >
              <mat-icon>first_page</mat-icon>
            </button>
            <button
              disableRipple
              mat-icon-button
              [disabled]="pageIndex <= 1"
              (click)="getPreviousPage()"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              disableRipple
              mat-icon-button
              [disabled]="this.to >= length"
              (click)="getNextPage()"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
            <button
              disableRipple
              mat-icon-button
              [disabled]="this.to >= length"
              (click)="getLastPage()"
            >
              <mat-icon>last_page</mat-icon>
            </button>
          </span>
        </span>
      </mat-toolbar>
      }
    </div>
  </mat-card>
  }
</div>

@if (isMobile && isDriver) {
<div class="cards-container">
  @for (item of dataSource?.data; track item) {
  <div class="card-container">
    <div class="card-header">
      <div class="text-center">
        <span [ngStyle]="{ color: item.orderStatus === 'New' ? '#0081ff' : '#ff8a48' }">{{
          item.orderStatus
        }}</span>
        <p style="margin-bottom: 0">{{ item.timeDif }}</p>
      </div>
      <div>ID : {{ item.uniqueOrderId }}</div>
    </div>
    <div class="card-body">
      <div>
        <p><span class="card-label">NAME: </span>{{ item.firstName + ' ' + item.lastName }}</p>
        <p (click)="openGoogleMaps(item.latitude, item.longitude)">
          <span class="card-label">ADDRESS: </span>
          <span>{{ item.addr1 ? item.addr1 + ', ' : '' }}</span>
          <span>{{ item.addr2 ? item.addr2 + ', ' : '' }}</span>
          <span
            >{{ item.addsuburb ? item.addsuburb + ', ' : '' }}
            {{ item.addstate ? item.addstate + ', ' : '' }}
            {{ item.addpostcode || ''
            }}<mat-icon color="accent" class="mr-4">location_on</mat-icon>
          </span>
        </p>

        <p>
          <span class="card-label">TYPE: </span
          ><span
            [ngClass]="{
              'mm-text-pink': item.delivery_Tracking != null,
              'has-link': item.delivery_Tracking != null
            }"
            (click)="openDeliveryTracking(item.delivery_Tracking)"
            >{{ item.deliveryPartnerName }}</span
          >
        </p>
        <p style="margin-bottom: 0">
          <span class="card-label">DELIVERY INSTRUCTIONS:</span>
          {{ item.delivery_instructions }}
        </p>
      </div>
    </div>
    @if ( item.orderStatus!=='Awaiting Delivery') {
    <div class="card-footer">
      <a [href]="'tel:' + item.mobile" class="cta call-button"> Call </a>
      <div class="cta return-button" (click)="onQuickAction(item, 'Return')">
        <p class="cta-text">Return</p>
      </div>
      <div class="completed-button" (click)="onQuickAction(item, 'Completed')">
        <p class="cta-text">Delivered</p>
      </div>
    </div>
    } @if (item.orderStatus==='Awaiting Delivery') {
    <div class="card-footer-2" (click)="onQuickAction(item, 'In Transit')">
      <p class="cta-text">Collected</p>
    </div>
    }
  </div>
  }
</div>
}
